import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./Homepage.css";

import WhyUs from "./WhyUs";
import PropWorth from "../../assets/images/prop-worth.jpg";
import { CiCircleCheck } from "react-icons/ci";

import SlickList2 from "../SlickList2";
import SearchBarWithDropdown from "../SearchBarWIthDropdownStates";
import Navbar from "../Navbar";
import Footer from "../footer";
import assetContext from "../../context/AssetsContext/AssetContext";
// import Banner from "../../assets/images/test_banner.png";
import GBanner from "../../assets/images/guides-bg.png";
import Market11 from "../../assets/images/market11.png";
import Market22 from "../../assets/images/market22.png";
import Market3 from "../../assets/images/market3.jpg";

import F1 from "../../assets/images/a/valuation.png";
import F2 from "../../assets/images/a/marketing.png";
import F3 from "../../assets/images/a/site-visit.png";
import F4 from "../../assets/images/a/feedback.png";
import F5 from "../../assets/images/a/somehow.png";

// import Banner from "../../assets/images/background_banner.png";
// import SittingOnKey1 from "../../assets/images/man_sitting_on_key1.png";
// import ManShowingRightHand from "../../assets/images/man_showing_right_hand.png";
// import ManHand from "../../assets/images/hand_man.png";
// import WomanHand from "../../assets/images/hand_woman.png";
// import MomAndSon from "../../assets/images/mom_and_son_hand.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import ImageSlider from "../ImageSlider";
// import Landingpage from "./Landingpage";
// import DropdownSearch from "./DropdownSearch";
import ImageSlider1 from "./ImageSlider1";
import Landingpage1 from "./LandingPage1";
import FAQ from "../FAQ/FAQ";

const Homepage = () => {
  return (
    <div
      style={{
        overflowX: "hidden",
        width: "100%",
      }}
    >
      <Navbar />
      <ToastContainer position="top-center" />

      {/* <Card2Example /> */}
      {/* <Carousel1/> */}
      {/* <Card4/> */}

      {/* <ImageAccordionExample/> */}
      {/* <Carousel2/> */}

      {/* <div
        style={{
          width: "100%",
           display: "flex",
          justifyContent: "center",
          alignItems: "center",
           backgroundRepeat: "no-repeat",
          objectFit: "top-center",
           backgroundImage: `url(${Banner})`,
        }}
        className=" h-[120vh] sm:h-[100vh]"
      >
        <div
          style={{
            position: "relative",
          
          }}
          className="h-[120vh] sm:h-[80vh] w-90vw sm:w-80vw md:w-60vw mx-6"
        >
          <div
            style={{
              position: "absolute",
              width: "100%",
              color: "#ffffff",
 
            }}
            className="md:p-[20px] h-[100vw]"
          >
            <div
              className="flex flex-col justify-start items-start xl:justify-center xl:items-center "
               >
              <div className="flex px-0  flex-row  justify-start items-start lg:justify-center lg:items-center">
                <h1 className="text-2xl font-bold text-center text-white">
                  #Sell
                </h1>
                <h1 className="text-2xl font-bold text-center text-white">
                  SMART
                </h1>
              </div>

              <div className="  justify-start items-start lg:justify-center lg:items-center">
                <h1
                  style={{ color: "white" }}
                  className="text-xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-2xl  font-bold text-start md:text-center"
                >
                  Resell Properties
                </h1>
                <h1
                  style={{ color: "white" }}
                  className="text-md   md:text-lg lg:text-md xl:text-xl  text-center"
                >
                  - Sell your house in 45 days
                </h1>
              </div>
            </div>
            
              <SearchBarWithDropdown
                onDataReceived={handleDataReceived}
                locationaOptions={
                  availableFilters !== null &&
                  availableFilters.property_location.length > 0
                    ? availableFilters.property_location
                    : []
                }
                configOptions={
                  availableFilters !== null &&
                  availableFilters.property_bhk.length > 0
                    ? availableFilters.property_bhk
                    : []
                }
                style={{ width: "100%", backgroundColor: "black" }}
              />
            
          
          </div>

          <div
            style={{
              position: "absolute",
              right: 0,
              height: "20vh",
            }}
            className="block xl:hidden top-2  sm:-top-4 w-[100px] sm:w-[150px]"
          >
            <img src={SittingOnKey1} />
          </div>

          <div
            className="hidden xl:block absolute mt-[2vh] -right-[23vh]"
            // className="hidden xl:block absolute mt-[-5px] h-[100vw] right-[-300]"
          >
            <img
              style={{
                height: "80vh",
              }}
              src={ManShowingRightHand}
            />
          </div>

          <div className="hidden xl:block absolute -mt-[2vh]  -left-[27vh]">
            <img
              style={{
                height: "80vh",
              }}
              src={MomAndSon}
            />
          </div>
        </div>
      </div> */}
      <Landingpage1 />

      <div
        style={{
          width: "100vw",
          // backgroundColor: "black",
          maxWidth: "100vw",
        }}
      >
        <ImageSlider1 />
      </div>

      {/* <WhyUs /> */}

      <section class="w-full bg-white pt-7 pb-7 md:pt-20 md:pb-24">
        <div className=" flex flex-col justify-center items-center space-y-3">
          <p
            style={{
              textAlign: "center",
              fontFamily: "Playfair Display, sans-serif",
            }}
            className="text-gray-800 text-3xl font-semibold sm:text-4xl"
          >
            Your property is our responsibility
          </p>
          <p
            style={{
              textAlign: "center",
            }}
          >
            Why Choose Us as Your Exclusive Sales Partner?
          </p>
        </div>
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
          }}
          class="box-border flex flex-col items-center content-center px-8 mx-auto leading-6 text-black border-0 border-gray-300 border-solid md:flex-row max-w-7xl lg:px-16"
        >
          <div class="box-border relative w-full max-w-md px-4 mt-5 mb-4 -ml-5 text-center bg-no-repeat bg-contain border-solid md:ml-0 md:mt-0 md:max-w-none lg:mb-0 md:w-1/2 xl:pl-10">
            <img src={F1} class="p-2 pl-6 pr-5 xl:pl-16 xl:pr-20 " alt="" />
          </div>

          <div class="box-border order-first w-full text-black border-solid md:w-1/2 md:pl-10 md:order-none">
            <h2
              style={{
                fontFamily: "Playfair Display, sans-serif",
              }}
              class="m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl"
            >
              Valuation and Consultation
            </h2>
            <p class="pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-12 xl:pr-32 lg:text-lg">
              Finding the best price for your property is the biggest challenge.
              Not anymore.
            </p>
            <ul class="p-0 m-0 leading-6 border-0 border-gray-300">
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Accurate, market-based valuation
              </li>
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Expert property consultation
              </li>
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Smart pricing strategy
              </li>
            </ul>
          </div>
        </div>
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
          }}
          class="box-border flex flex-col items-center content-center px-8 mx-auto mt-2 leading-6 text-black border-0 border-gray-300 border-solid md:mt-20 xl:mt-0 md:flex-row max-w-7xl lg:px-16"
        >
          <div class="box-border w-full text-black border-solid md:w-1/2 md:pl-6 xl:pl-32">
            <h2
              style={{
                fontFamily: "Playfair Display, sans-serif",
              }}
              class="m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl"
            >
              Free Marketing
            </h2>
            <p class="pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-10 lg:text-lg">
              We advertise your property. For free! Direct and Cross.
            </p>
            <ul class="p-0 m-0 leading-6 border-0 border-gray-300">
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Listed on top platforms
              </li>
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Cross-channel promotion
              </li>
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Professional media support
              </li>
            </ul>
          </div>

          <div class="box-border relative w-full max-w-md px-4 mt-10 mb-4 text-center bg-no-repeat bg-contain border-solid md:mt-0 md:max-w-none lg:mb-0 md:w-1/2">
            <img src={F2} class="pl-4 sm:pr-10 xl:pl-10 lg:pr-32" alt="" />
          </div>
        </div>
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
          }}
          class="box-border flex flex-col items-center content-center px-8 mx-auto leading-6 text-black border-0 border-gray-300 border-solid md:flex-row max-w-7xl lg:px-16"
        >
          <div class="box-border relative w-full max-w-md px-4 mt-5 mb-4 -ml-5 text-center bg-no-repeat bg-contain border-solid md:ml-0 md:mt-0 md:max-w-none lg:mb-0 md:w-1/2 xl:pl-10">
            <img src={F3} class="p-2 pl-6 pr-5 xl:pl-16 xl:pr-20 " alt="" />
          </div>

          <div class="box-border order-first w-full text-black border-solid md:w-1/2 md:pl-10 md:order-none">
            <h2
              style={{
                fontFamily: "Playfair Display, sans-serif",
              }}
              class="m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl"
            >
              Genuine Visits
            </h2>
            <p class="pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-12 xl:pr-32 lg:text-lg">
              We ensure that only interested buyers visit your property.
            </p>
            <ul class="p-0 m-0 leading-6 border-0 border-gray-300">
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Pre-qualified buyers only
              </li>
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Visits scheduled to suit you
              </li>
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Relevant buyer matching
              </li>
            </ul>
          </div>
        </div>
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
          }}
          class="box-border flex flex-col items-center content-center px-8 mx-auto mt-2 leading-6 text-black border-0 border-gray-300 border-solid md:mt-20 xl:mt-0 md:flex-row max-w-7xl lg:px-16"
        >
          <div class="box-border w-full text-black border-solid md:w-1/2 md:pl-6 xl:pl-32">
            <h2
              style={{
                fontFamily: "Playfair Display, sans-serif",
              }}
              class="m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl"
            >
              Regular Feedbacks
            </h2>
            <p class="pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-10 lg:text-lg">
              We provide you with real-time feedback from prospective buyers.
            </p>
            <ul class="p-0 m-0 leading-6 border-0 border-gray-300">
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Quick post-visit updates
              </li>
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Honest buyer insights
              </li>
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Improvement suggestions
              </li>
            </ul>
          </div>

          <div class="box-border relative w-full max-w-md px-4 mt-10 mb-4 text-center bg-no-repeat bg-contain border-solid md:mt-0 md:max-w-none lg:mb-0 md:w-1/2">
            <img src={F4} class="pl-4 sm:pr-10 xl:pl-10 lg:pr-32" alt="" />
          </div>
        </div>
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
          }}
          class="box-border flex flex-col items-center content-center px-8 mx-auto leading-6 text-black border-0 border-gray-300 border-solid md:flex-row max-w-7xl lg:px-16"
        >
          <div class="box-border relative w-full max-w-md px-4 mt-5 mb-4 -ml-5 text-center bg-no-repeat bg-contain border-solid md:ml-0 md:mt-0 md:max-w-none lg:mb-0 md:w-1/2 xl:pl-10">
            <img src={F5} class="p-2 pl-6 pr-5 xl:pl-16 xl:pr-20 " alt="" />
          </div>

          <div class="box-border order-first w-full text-black border-solid md:w-1/2 md:pl-10 md:order-none">
            <h2
              style={{
                fontFamily: "Playfair Display, sans-serif",
              }}
              class="m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl"
            >
              Negotiation and Sale
            </h2>
            <p class="pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-12 xl:pr-32 lg:text-lg">
              We value our fee, but far more than that, we value your
              relationship.
            </p>
            <ul class="p-0 m-0 leading-6 border-0 border-gray-300">
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Strong deal negotiation
              </li>
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                Full paperwork support
              </li>
              <li class="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
                <span
                  class="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full"
                  data-primary="yellow-400"
                >
                  <span class="text-sm font-bold">✓</span>
                </span>{" "}
                End-to-end guidance
              </li>
            </ul>
          </div>
        </div>
      </section>

      <div
        style={{
          backgroundColor: "#f6f7f9",

          borderRadius: 20,

          textAlign: "center",
        }}
        className="pb-10 lg:p-100  max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 justify-center items-start    border border-white border-1"
      >
        <div className=" ">
          <img
            style={{
              borderRadius: 10,
              width: "100%",

              objectFit: "cover",
            }}
            src={Market11}
            alt="Virtualtour"
          />
        </div>
        <div
          style={{
            fontFamily: "Playfair Display, sans-serif",
          }}
          className="flex flex-col justify-start items-start"
        >
          <h2
            style={{
              marginTop: "10px",
              //  fontSize: "30px",
              //color:"#9379B8",
              paddingLeft: 30,
              textAlign: "start",
              fontWeight: "bolder",
            }}
            className="text-2xl md:text-4xl "
          >
            Market Value by RESELL.PROPERTIES
          </h2>
          <h2
            style={{
              marginTop: "10px",
              //  fontSize: "30px",

              //color:"#9379B8",
              paddingLeft: 30,
              textAlign: "start",
            }}
            className="text-xl md:text-2xl"
          >
            Evaluate the market value of any property in your area, project, or
            locality.
          </h2>

          <p
            style={{
              margin: "10px 0px",
              // fontSize: "18px",
              fontWeight: 500,

              fontFamily: "Poppins, sans-serif",
              color: "#5f6063",
              textAlign: "start",
              fontSize: 16,
              paddingLeft: 30,
            }}
          >
            Pricing your property correctly is the crucial aspect of the real
            estate transaction . Leveraging market trends and in-depth property
            analysis, we ensure your property is priced just right, maximizing
            returns while ensuring a quick sale thus unlocking a successful
            property sale.
          </p>

          <div className="flex fex-row flex-wrap gap-y-10 m-10 gap-x-4">
            <div className="flex flex-row justify-center items-center">
              <div>
                <CiCircleCheck
                  size={30}
                  style={{
                    color: "green",
                  }}
                />
              </div>

              <label
                style={{
                  color: "grey",
                  textAlign: "start",
                }}
                className="pl-2 font-sans "
              >
                Reliable and Up-to-Date Market Data
              </label>
            </div>

            <div className="flex flex-row justify-center items-center">
              <div>
                <CiCircleCheck
                  size={30}
                  style={{
                    color: "green",
                  }}
                />
              </div>
              <label
                style={{
                  color: "grey",
                  textAlign: "start",
                }}
                className="pl-2 font-sans"
              >
                Easy and Quick Valuation
              </label>
            </div>
            <div className="flex flex-row justify-center items-center">
              <div>
                <CiCircleCheck
                  size={30}
                  style={{
                    color: "green",
                  }}
                />
              </div>
              <label
                style={{
                  color: "grey",
                  textAlign: "start",
                }}
                className="pl-2 font-sans"
              >
                Trusted by Thousands of Homeowners and Investors
              </label>
            </div>
          </div>

          <a
            href="/contact"
            style={{
              color: "#9379B8",
            }}
            className="  mt-2  pl-8 font-sans underline"
          >
            Check Your Property's Worth Now!
          </a>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto my-20 p-0 lg:p-100">
        <img style={{borderRadius:25}} src={GBanner} className="w-full object-cover  " alt="" />

        <section
          style={{ fontFamily: "Playfair Display, sans-serif" }}
          className="absolute bottom-0 left-1/2 w-full transform -translate-x-1/2 bg-white lg:bg-transparent bg-opacity-90 text-center px-4 py-6 sm:py-10 md:py-12 lg:py-16"
        >
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl max-w-3xl mx-auto font-bold text-gray-900 mb-4 sm:mb-6">
            Whether you own or plan to own a home, we’ve got something special
            for you.
          </h1>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-6 sm:mb-8 max-w-4xl mx-auto">
            From finding your dream home to unlocking your property’s true
            value, we’re here to guide you every step of the way. Discover
            curated options designed to match your needs and lifestyle.
          </p>
          <button className="bg-purple-700 text-white px-5 py-2 sm:px-6 sm:py-3 rounded-full shadow-md hover:bg-purple-800 transition">
            <a href="/homeowner">Explore Your Options</a>
          </button>
        </section>
      </div>

      <div
        style={
          {
            //  backgroundColor: "#efecff",
          }
        }
        className="px-2 py-6 max-w-7xl mx-auto"
      >
        <div
          style={{
            padding: 30,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              fontSize: "20px",
              fontWeight: 600,
              fontFamily: "Poppins, sans-serif",
            }}
          >
            Top Commuinities
          </div>
          <a
            href="/featured"
            className="hidden md:block flex items-center justify-center gap-x-1 py-2 px-4 text-white font-medium bg-gray-800 hover:bg-gray-700 active:bg-gray-900 border-2 border-black  rounded-md md:inline-flex"
          >
            Show all communities
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="w-5 h-5"
            >
              <path
                fillRule="evenodd"
                d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                clipRule="evenodd"
              />
            </svg>
          </a>
        </div>

        <SlickList2 />
      </div>

      <section className="py-14 max-w-screen-xl mx-auto">
        <div className="relative overflow-hidden mx-4 px-4 py-14 rounded-2xl bg-blue-600 md:px-8 md:mx-8">
          <div className="relative z-10 max-w-xl mx-auto sm:text-center">
            <div className="space-y-3">
              <h3 className="text-3xl text-white font-bold">
                Subscribe to our newsletter
              </h3>
              <p className="text-blue-100 leading-relaxed">
                Stay up to date with the roadmap progress, announcements and
                exclusive discounts feel free to sign up with your email.
              </p>
            </div>
            <div className="mt-6">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="flex items-center justify-center gap-4 bg-white rounded-lg p-1 sm:max-w-md sm:mx-auto"
              >
                <input
                  type="email"
                  required
                  placeholder="Enter email"
                  className="w-full  px-3 py-2 text-gray-500 bg-transparent rounded-lg border-none outline-none"
                />
                <button className="p-2 px-3 rounded-lg font-medium text-white bg-blue-600 hover:bg-blue-500 active:bg-blue-700 duration-150 outline-none shadow-md focus:shadow-none sm:px-4">
                  Subscribe
                </button>
              </form>
              <p className="mt-3 max-w-lg text-[15px] text-blue-100 sm:mx-auto">
                No spam ever, we are care about the protection of your data.
                Read our{" "}
                <a className="underline" href="/">
                  {" "}
                  Privacy Policy{" "}
                </a>
              </p>
            </div>
          </div>
          <div
            className="absolute inset-0 w-full h-full"
            style={{
              background:
                "linear-gradient(268.24deg, rgba(59, 130, 246, 0.76) 50%, rgba(59, 130, 246, 0.545528) 80.61%, rgba(55, 48, 163, 0) 117.35%)",
            }}
          ></div>
        </div>
      </section>
      <FAQ />

      <Footer />
    </div>
  );
};

export default Homepage;
